module.exports = __webpack_public_path__ + "static/img/ucenter_08.df888a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ucenter_08.jpg
// module id = Rowc
// module chunks = 29